import React from 'react';
import styled from 'styled-components';
import { Button as MaterialButton } from '@material-ui/core';

const StyledButton = styled(MaterialButton)`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    width: ${({ width }) => `${width}%`};
`;

const Button = ({ children, variant, color, mt, width, type, onClick, disabled }) => (
    <StyledButton
        variant={variant}
        color={color}
        mt={mt}
        width={width}
        type={type}
        onClick={onClick}
        disabled={disabled}
    >
        {children}
    </StyledButton>
);

export default Button;
